import { gql } from '@apollo/client';

export const GET_FEATURED_ADS_QUERY = gql`
    query GetFeaturedAds($offset: Int!, $limit: Int!) {
        allFeaturedAd(
            limit: $limit
            offset: $offset
            sort: { publishedAt: DESC }
            where: {
                _: { is_draft: false }
            }
        ) {
            title
            subtitle
            cta
            url
            image {
                altText
                asset {
                    _id
                    url
                }
                hotspot {
                    x
                    y
                    height
                    width
                }
                crop {
                    top
                    bottom
                    left
                    right
                }
            }
            publishedAt
        }
    }
`;
